import type { RouteLocationRaw } from 'vue-router'
import useUserStore from '@/store/user'

export function loginRouteAfterSetup(): RouteLocationRaw {
  return { path: '/login', query: { from: 'setup' } }
}

export async function logoutAndGoToLoginAfterSetup(
  replace: (to: RouteLocationRaw) => void,
) {
  const userStore = useUserStore()
  await userStore.logout()
  replace(loginRouteAfterSetup())
}
